import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function composeRenderProps<T, U, V extends T>(
	value: T extends any ? T | ((renderProps: U) => V) : never,
	wrap: (prevValue: T, renderProps: U) => V
): (renderProps: U) => V {
	return renderProps => wrap(typeof value === 'function' ? value(renderProps) : value, renderProps)
}
